export default {"src":"/_next/static/media/reference.bae34f51.svg","height":32,"width":24,"blurWidth":0,"blurHeight":0};